import { useAuth } from '../../../context/AuthContext';
import { dictionary } from '../../../utils/dictionary';

interface ImportProductFromLinkHeaderProps {
  name?: string;
}

const platformLogos = [
  {
    src: "https://i.ibb.co/NdnhLqqH/ali.png",
    alt: "AliExpress"
  },
  {
    src: "https://www.svgrepo.com/show/303503/shopify-logo.svg",
    alt: "Shopify"
  },
  {
    src: "https://upload.wikimedia.org/wikipedia/commons/4/4a/Amazon_icon.svg",
    alt: "Amazon"
  },
  {
    src: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTIXvb1uc1DLyblcMGgEtWTLtXEYzuBfvZ6UQ&s",
    alt: "Etsy"
  },
  {
    src: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQKVO4c8b5IsJUTtIjl5ShRPxonqTUzDvD3vw&s",
    alt: "eBay"
  },
  {
    src: "https://fluxi.co/dev/assets/images/dropi-logo-1.webp",
    alt: "Dropi"
  }
];

function ImportProductFromLinkHeader({ name = 'product' }: ImportProductFromLinkHeaderProps) {
  const { language } = useAuth();
  
  return (
    <div className="flex justify-between items-center mb-4">
      <h4 className="text-lg font-medium">{dictionary[`import-${name}-from-link`][language]}</h4>
      <div className="flex items-center space-x-2">
        {platformLogos.map((logo, index) => (
          <div key={index} className="bg-gray-100 p-1 rounded-md">
            <img
              src={logo.src}
              alt={logo.alt}
              className="h-5 w-5 rounded-md"
            />
          </div>
        ))}
      </div>
    </div>
  );
}

export default ImportProductFromLinkHeader;
